import { render } from "./add-lesson.vue?vue&type=template&id=75da86c5"
import script from "./add-lesson.vue?vue&type=script&lang=js"
export * from "./add-lesson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__